import Cookies from 'js-cookie';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';

const subscribeDrawRoomList = {};
const subscribeChatRoomList = {};

function getSessionId() {
  return Cookies.get('sessionId') || '';
}

export function connectWebSocket(stompClient, onConnect, onDisconnect) {
  if (stompClient && stompClient.connected) {
    return Promise.resolve(stompClient); // 이미 연결되어 있으면 바로 리턴
  }

  return new Promise((resolve, reject) => {
    const socket = new SockJS(process.env.VUE_APP_API_URL + '/ws');
    stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,

      onConnect: () => {
        if (onConnect) onConnect();
        resolve(stompClient); // 연결 완료되면 리턴
      },

      onStompError: (frame) => {
        console.error("STOMP error:", frame);
        reject(new Error("STOMP error"));
      },

      onDisconnect: () => {
        if (onDisconnect) onDisconnect();
      }
    });

    stompClient.activate();
  });
}

export function disconnectWebSocket(stompClient) {
  if (stompClient) {
      stompClient.deactivate();
  }
  return null;
}

export function subscribeDrawRoom(stompClient, roomId, onMessage) {
  if (subscribeDrawRoomList[roomId]) return; 
  if (stompClient && stompClient.connected) {
    const subscription = stompClient.subscribe(`/sub/draw/${roomId}`, (message) => {
        onMessage(JSON.parse(message.body));
      }, { 'simple-session-id': getSessionId() }
    );
    subscribeDrawRoomList[roomId] = subscription;
  }
}

export function unsubscribeDrawRoom(stompClient, roomId) {
  if (stompClient && subscribeDrawRoomList[roomId]) {
    const subscription = subscribeDrawRoomList[roomId];
    subscription.unsubscribe();
    delete subscribeDrawRoomList[roomId];
  } 
}

export function sendDrawMessage(stompClient, roomId, data) {
  if (stompClient && stompClient.connected) {
    stompClient.publish({
      destination: `/pub/draw/${roomId}`,
      body: JSON.stringify(data),
    });
  }
} 


export function subscribeChatRoom(stompClient, roomId, onMessage) {
  if (subscribeChatRoomList[roomId]) return;
  if (stompClient && stompClient.connected) {
    const subscription = stompClient.subscribe(`/sub/chat/${roomId}`,
      (message) => { onMessage(JSON.parse(message.body)); },
      { 'simple-session-id': getSessionId() }
    );
    subscribeChatRoomList[roomId] = subscription;
  }
}

export function unsubscribeChatRoom(stompClient, roomId) {
  if (stompClient && subscribeChatRoomList[roomId]) {
    const subscription = subscribeChatRoomList[roomId];
    subscription.unsubscribe();
    delete subscribeChatRoomList[roomId];
  }
}

export function sendChatMessage(stompClient, roomId, message) {
  if (stompClient && stompClient.connected) {
    stompClient.publish({
      destination: `/pub/chat/${roomId}`,
      body: JSON.stringify({ content: message, sessionId: getSessionId() }),
    });
  }
}